import React from "react";
import { Sparkles, Zap, CalendarClock, Gauge } from "lucide-react";

// Painel de uso: instruções geradas + créditos restantes (grátis) ou tempo de acesso (pago).
export function UsagePanel({ userState }) {
  if (!userState) return null;

  const generated = userState.questions_used ?? 0;

  return (
    <div className="grid grid-cols-2 gap-3" data-testid="usage-panel">
      <div className="glass rounded-2xl p-4">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
          <Gauge className="h-4 w-4 text-violet-300" /> Instruções geradas
        </div>
        <div className="mt-2 font-display text-3xl font-extrabold text-white" data-testid="usage-generated">
          {generated}
        </div>
      </div>

      {userState.is_paid ? (
        <div className="glass rounded-2xl p-4">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
            <CalendarClock className="h-4 w-4 text-emerald-300" /> Acesso expira em
          </div>
          <div className="mt-2 font-display text-3xl font-extrabold text-emerald-400" data-testid="usage-days-left">
            {userState.days_remaining ?? 0}
            <span className="ml-1 text-base font-semibold text-slate-400">dias</span>
          </div>
        </div>
      ) : (
        <div className="glass rounded-2xl p-4">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
            <Zap className="h-4 w-4 text-violet-300" /> Créditos restantes
          </div>
          <div className="mt-2 font-display text-3xl font-extrabold text-white" data-testid="usage-credits-left">
            {userState.credits_remaining ?? 0}
            <span className="ml-1 text-base font-semibold text-slate-400">de 3</span>
          </div>
        </div>
      )}
    </div>
  );
}
